import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";

// Import components for routes
import Contact from "./components/Contact";
import About from "./components/About";
import Blog from "./components/Blog"; // Import BlogList component
import Root from "./components/Root";
import ErrorPage from "./components/ErrorPage";
import BlogPost from "./components/BlogPost"; // Import the new BlogPost component
import HelpAndSupport from "./components/HelpandSupport";
import TermsAndConditions from "./components/TermsAndConditions";
import TermsOfUse from "./components/TermOfUse";
import PrivacyPolicy from "./components/Privacy";
import Career from "./components/Carrer";
import Pricing from "./components/pricing";
import Login from "./components/Login";
import { OtpScreen, Signup } from "./components/SignUp";
import LandingPage from "./components/LandingPage";
import AdminDashboard from "./components/AdminDashboard";
import Users from "./components/Users";
import NewUsers from "./components/NewUsers";
import UserDetails from "./components/UserDetails";
import EditProfileScreen from "./components/EditProfileScreen";
import Matches from "./components/Matches";
import MatchPairComparison from "./components/MatchPairComparison";
import MatchDataChecks from "./components/MatchDataChecks";
import MembersOverview from "./components/MembersOverview";
import PromptEditor from "./components/PromptEditor";
import ProtectedRoute from "./components/features/ProtectedRoute";
import PostmanMini from "./components/PostmanMini";
import WhatsAppPage from "./components/Whatsapp/WhatsappPage";
import TemplateCatalogView from "./components/Whatsapp/TemplateCatalogView";
import Version from "./components/Version";
import Transactions from "./components/Transactions";
import UnregisteredUsers from "./components/UnregisteredUsers";
import AdminServices from "./components/AdminServices";
import EmployeeAttendance from "./components/EmployeeAttendance";
import InterestedUsers from "./components/InterestedUsers";
import AdminManagement from "./components/AdminManagement";
import Subscriptions from "./components/Subscriptions";
import MarketingStats from "./components/MarketingStats";
import GoogleOverview from "./components/GoogleOverview";
import DropdownData from "./components/DropdownData";
import ErrorLogs from "./components/ErrorLogs";
import DockerManagement from "./components/DockerManagement";
import PostgresStats from "./components/PostgresStats";
import CacheManagement from "./components/CacheManagement";
import AIAgentChat from "./components/AIAgentChat";
import LLMLogs from "./components/LLMLogs";
import HotLeads from "./components/HotLeads";
import TeamActionQueue from "./components/TeamActionQueue";
import AdminLogs from "./components/Logs/AdminLogs";
import ApiLogs from "./components/Logs/ApiLogs";
import UserUpdateValues from "./components/Logs/UserUpdateValues";
import EventsManagement from "./components/EventsManagement";
import ServiceLogs from "./components/ServiceLogs";
import UsersWithoutMatchesToday from "./components/UsersWithoutMatchesToday";
import CouponManagement from "./components/CouponManagement";
import DocumentsDashboard from "./components/Documents/DocumentsDashboard";
import DocumentDetails from "./components/Documents/DocumentDetails";
import UploadDocument from "./components/Documents/UploadDocument";
import EditDocument from "./components/Documents/EditDocument";
import SalesTeamDashboard from "./components/SalesTeamDashboard";
import TeamMemberActivity from "./components/TeamMemberActivity";
import WhatsAppBiodataMedia from "./components/WhatsAppBiodataMedia";
import OnboardingSmmExport from "./components/OnboardingSmmExport";
import SpecialPreferenceUsers from "./components/SpecialPreferenceUsers";
import BiodataNonUserExport from "./components/BiodataNonUserExport";
import AppAnalytics from "./components/AppAnalytics";
import GooglePlayConsole from "./components/GooglePlayConsole";
import StateCityAnalytics from "./components/StateCityAnalytics";

const DOCUMENT_ROLES = ["super_admin", "admin", "subadmin", "moderator"];

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <LandingPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "blogs",
        element: <Blog />, // Render BlogList component here
      },
      {
        path: "blogs/:slug",
        element: <BlogPost />, // Render BlogPost component here
      },
      {
        path: "/helpAndSupport",
        element: <HelpAndSupport />,
      },
      {
        path: "/termsandconditions",
        element: <TermsAndConditions />,
      },
      {
        path: "/terms/termofuse",
        element: <TermsOfUse />,
      },
      {
        path: "/terms/privacy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/pricing",
        element: <Pricing />,
      },
      {
        path: "/careers",
        element: <Career />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/signup",
        element: <Signup />,
      },
      {
        path: "/otp",
        element: <OtpScreen />,
      },
      {
        path: "/postman",
        element:  <PostmanMini />,
      },
      {
        path: "/dashboard",
        element: (
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/sales-team-dashboard",
        element: (
          <ProtectedRoute>
            <SalesTeamDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/team-activity",
        element: (
          <ProtectedRoute>
            <TeamMemberActivity />
          </ProtectedRoute>
        ),
      },
      {
        path: "/users",
        element:(
          <ProtectedRoute>
            <Users />
          </ProtectedRoute>
        ),
      },
      {
        path: "/special-preference-users",
        element: (
          <ProtectedRoute>
            <SpecialPreferenceUsers />
          </ProtectedRoute>
        ),
      },
      {
        path: "/new-users",
        element:(
          <ProtectedRoute>
            <NewUsers />
          </ProtectedRoute>
        ),
      },
      {
        path: "/state-city-analytics",
        element: (
          <ProtectedRoute exactRoles={["admin", "super_admin", "support"]}>
            <StateCityAnalytics />
          </ProtectedRoute>
        ),
      },
      {
        path: "/matches",
        element: (
          <ProtectedRoute>
            <Matches />
          </ProtectedRoute>
        ),
      },
      {
        path: "/matches/:userId",
        element: (
          <ProtectedRoute>
            <Matches />
          </ProtectedRoute>
        ),
      },
      {
        path: "/match-pair",
        element: (
          <ProtectedRoute>
            <MatchPairComparison />
          </ProtectedRoute>
        ),
      },
      {
        path: "/match-data-checks",
        element: (
          <ProtectedRoute roles={["admin", "super_admin"]}>
            <MatchDataChecks />
          </ProtectedRoute>
        ),
      },
      {
        path: "/app-analytics",
        element: (
          <ProtectedRoute roles={["admin", "super_admin"]}>
            <AppAnalytics />
          </ProtectedRoute>
        ),
      },
      {
        path: "/google-play-console",
        element: (
          <ProtectedRoute roles={["admin", "super_admin"]}>
            <GooglePlayConsole />
          </ProtectedRoute>
        ),
      },
      {
        path: "/members-overview",
        element: (
          <ProtectedRoute>
            <MembersOverview />
          </ProtectedRoute>
        ),
      },
      {
        path: "/users-without-matches-today",
        element: (
          <ProtectedRoute>
            <UsersWithoutMatchesToday />
          </ProtectedRoute>
        ),
      },
      {
        path: "/whatsapp",
        element:(
          <ProtectedRoute>
            <WhatsAppPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/whatsapp-templates",
        element:(
          <ProtectedRoute>
            <TemplateCatalogView />
          </ProtectedRoute>
        ),
      },
      {
        path: "/prompts",
        element: (
          <ProtectedRoute>
            <PromptEditor />
          </ProtectedRoute>
        ),
      },
      {
        path: "/users/user/:userIdParams",
        element: (
          <ProtectedRoute>
            <UserDetails />
          </ProtectedRoute>
        ),
      },
      {
        path: "/users/edit/:userIdParams",
        element: (
          <ProtectedRoute>
            <EditProfileScreen />
          </ProtectedRoute>
        ),
      },
      {
        path: "/version",
        element: (
          <ProtectedRoute  roles={["admin",   "super_admin"]}>
            <Version />
           </ProtectedRoute>
        )
      },
      {
        path: "/transactions",
        element: (
          <ProtectedRoute>
            <Transactions />
          </ProtectedRoute>
        ),
      },
      {
        path: "/employees",
        element: (
          <ProtectedRoute>
            <UnregisteredUsers />
          </ProtectedRoute>
        ),
      },
      {
        path: "/admin-services",
        element: (
          <ProtectedRoute>
            <AdminServices />
          </ProtectedRoute>
        ),
      },
      {
        path: "/employee-attendance",
        element: <EmployeeAttendance />,
      },
      {
        path: "/interested-users",
        element: (
          <ProtectedRoute>
            <InterestedUsers />
          </ProtectedRoute>
        ),
      },
      {
        path: "/manage-admins",
        element: (
          <ProtectedRoute>
            <AdminManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "/subscriptions",
        element: (
          <ProtectedRoute>
            <Subscriptions />
          </ProtectedRoute>
        ),
      },
      {
        path: "/marketing-stats",
        element: (
          <ProtectedRoute>
            <MarketingStats />
          </ProtectedRoute>
        ),
      },
      {
        path: "/google-overview",
        element: (
          <ProtectedRoute>
            <GoogleOverview />
          </ProtectedRoute>
        ),
      },
      {
        path: "/dropdown-data",
        element: (
          <ProtectedRoute>
            <DropdownData />
          </ProtectedRoute>
        ),
      },
      {
        path: "/error-logs",
        element: (
          <ProtectedRoute>
            <ErrorLogs />
          </ProtectedRoute>
        ),
      },
      {
        path: "/admin-logs",
        element: (
          <ProtectedRoute>
            <AdminLogs />
          </ProtectedRoute>
        ),
      },
      {
        path: "/docker",
        element: (
          <ProtectedRoute>
            <DockerManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "/postgres",
        element: (
          <ProtectedRoute>
            <PostgresStats />
          </ProtectedRoute>
        ),
      },
      {
        path: "/cache-admin",
        element: (
          <ProtectedRoute>
            <CacheManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "/ai-agent",
        element: (
          <ProtectedRoute>
            <AIAgentChat />
          </ProtectedRoute>
        ),
      },
      {
        path: "/llm-logs",
        element: (
          <ProtectedRoute>
            <LLMLogs />
          </ProtectedRoute>
        ),
      },
      {
        path: "/events-management",
        element: (
          <ProtectedRoute>
            <EventsManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "/coupons",
        element: (
          <ProtectedRoute roles={["admin",   "super_admin"]}>
            <CouponManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "/documents",
        element: (
          <ProtectedRoute roles={DOCUMENT_ROLES}>
            <DocumentsDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/documents/:id",
        element: (
          <ProtectedRoute roles={DOCUMENT_ROLES}>
            <DocumentDetails />
          </ProtectedRoute>
        ),
      },
      {
        path: "/documents/upload",
        element: (
          <ProtectedRoute roles={DOCUMENT_ROLES}>
            <UploadDocument />
          </ProtectedRoute>
        ),
      },
      {
        path: "/documents/edit/:id",
        element: (
          <ProtectedRoute roles={DOCUMENT_ROLES}>
            <EditDocument />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hot-leads",
        element: (
          <ProtectedRoute>
            <HotLeads />
          </ProtectedRoute>
        ),
      },
      {
        path: "/team-action-queue",
        element: (
          <ProtectedRoute>
            <TeamActionQueue />
          </ProtectedRoute>
        ),
      },
      {
        path: "/service-logs",
        element: (
          <ProtectedRoute>
            <ServiceLogs />
          </ProtectedRoute>
        ),
      },
      {
        path: "/api-logs",
        element: (
          <ProtectedRoute>
            <ApiLogs />
          </ProtectedRoute>
        ),
      },
      {
        path: "/whatsapp-biodata-media",
        element: (
          <ProtectedRoute roles={["admin", "super_admin"]}>
            <WhatsAppBiodataMedia />
          </ProtectedRoute>
        ),
      },
      {
        path: "/onboarding-smm-export",
        element: (
          <ProtectedRoute roles={["admin", "super_admin"]}>
            <OnboardingSmmExport />
          </ProtectedRoute>
        ),
      },
      {
        path: "/biodata-non-user-export",
        element: (
          <ProtectedRoute roles={["admin", "super_admin"]}>
            <BiodataNonUserExport />
          </ProtectedRoute>
        ),
      },
      {
        path: "/user-update-values",
        element: (
          <ProtectedRoute>
            <UserUpdateValues />
          </ProtectedRoute>
        ),
      },
    ],
  },
]);

// App component renders RouterProvider with defined router
const App = () => (
  // <React.StrictMode>
  <RouterProvider router={router} />
  // </React.StrictMode>
);

export default App;
